import React from 'react'
import styled from 'styled-components'

import { ColumnFlex, Flex } from '~/components/basic/containers'
import { translate } from '~/services/translate'
import withTheme from '~/components/with-theme'
import { H4 } from '~/components/basic/headers'

const Content = styled(ColumnFlex)`
  box-shadow: 0px 6px 12px ${props => props.theme.colorDelimiter};
  padding: 40px 32px 32px;
  margin: auto;
  box-sizing: border-box;
  text-align: center;
  max-width: 340px;

  ${H4} {
    font-weight: 600;
    color: ${props => props.theme.grayFont};
  }
`

export default withTheme(() =>
  <Flex fullWidth fullHeight>
    <Content>
      <H4>
        {translate('unsupprted_page_description')}
      </H4>
    </Content>
  </Flex>
)
